<template>
<div>
    <!--<div class="carousel-indicators">
        <button alt="indicator" aria-label="indicator"
        class="carousel-indicator-item" 
        :class="{active: currentIndex === index}"
        v-for="(item, index) in total" 
        :key="index"
        @click="$emit('switch', index)"
        />
    </div>-->
    <div class="carousel-indicators idicators-texts">
        <button alt="indicator" aria-label="indicator"
        class="carousel-indicator-item el" 
        :class="{active: currentIndex === index}"
        v-for="(item, index) in total" 
        :key="index"
        @click="$emit('switch', index)"
        >
        {{rooms[item-1]}}
        </button>
        <button alt="indicator" aria-label="indicator"
        class="carousel-indicator-item en" 
        :class="{active: currentIndex === index}"
        v-for="(item, index) in total" 
        :key="index"
        @click="$emit('switch', index)"
        >
        {{roomsen[item-1]}}
        </button>
    </div>
</div>
</template>

<script>

export default{
    emits: ['switch'],
    props: ["total", "currentIndex"],
    data: () => ({
    rooms: [
      "Δίκλινο Δωμάτιο",
      "Τρίκλινο Δωμάτιο",
      "Δίκλινο Δωμάτιο",
    ],
    roomsen: [
      "Double Room",
      "Triple Room",
      "Double Room",
    ],
  }),
};
</script>


<style>

    .carousel-indicators {
        position: absolute;
        transform: translateX(-50%);
        left: 50%;
        bottom: 1.5em;
    }
    #app .carousel-indicators{
        position: absolute;
        transform: translateX(-50%);
        left: 18%;
        top: 13.5%;
        display: flex;
        flex-direction: column;
    }
    #app .carousel-item{
        padding-bottom: 20px !important;
    }
    #app .carousel-indicator-item{
        background: #000;
    }
    #app .carousel-inner{
        position: static !important;
    }
    .carousel-indicator-item{
        text-align: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        opacity: 0.7;
        border:none;
        background: #fff;
        margin:0.5em;
        border-radius: 40%;
        cursor: pointer;
    }
    .active{
        opacity: 1;
    }
    #app .carousel-indicators{
        background: #f2f2f2;
        height: max-content;
        padding: 0px 0px;
        align-items: center;
        text-align: center;
        border-radius: 5px;
    }
   
    #app .idicators-texts .carousel-indicator-item{
        width: auto !important;
        font-size: 15px !important;
        font-family: "ZonaPro";
        height: 30px;
        opacity: 0.7;
        border:none;
        background: transparent;
        margin:0em;
        border-radius: 0px;
        cursor: pointer;
        width: 100% !important;
        color:#000 !important;
        padding: 25px 20px;
        display: flex;
        align-items: center;
    }
    #app .idicators-texts .carousel-indicator-item:first-child{
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
    #app .idicators-texts .carousel-indicator-item:last-child{
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    #app .idicators-texts .active{
        opacity: 1;
        background: #507c29;
        color: #fff !important;
    }
</style>